import { render } from "./DocCmp.vue?vue&type=template&id=b5c84120&scoped=true"
import script from "./DocCmp.vue?vue&type=script&lang=js"
export * from "./DocCmp.vue?vue&type=script&lang=js"

import "./DocCmp.vue?vue&type=style&index=0&id=b5c84120&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c84120"]])

export default __exports__